export default {"src":"/_next/static/media/documentVerification.f3e402ff.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};